module.exports = __webpack_public_path__ + "img/f27cbca.png";